<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Engagement Types
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="nav-tree">
            <el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_eType_add')}}</el-button>
          </div>

          <el-table
            max-height="720"
            :data="tableData"
            :empty-text="$t('general_noData')"
            row-key="id"
            default-expand-all
            :tree-props="{children: 'stages'}"
            style="width: 100%">
            <el-table-column
              prop="order"
              label="ID"
              width="80">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('settings_eType_name')">
            </el-table-column>
            <el-table-column
            :label="$t('settings_eType_createdOn')"
              width="150">
              <template slot-scope="scope">
                {{moment(scope.row.createDate.toString(), 'X').format('D MMM YY')}}
              </template>
            </el-table-column>
            <el-table-column
              width="110"
              label="">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button @click="moveTypeStage(true, scope.row)" type="info" size="mini" icon="el-icon-top" plain></el-button>
                  <el-button @click="moveTypeStage(false, scope.row)" type="info" size="mini" icon="el-icon-bottom" plain></el-button>
                </el-button-group>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              :label="$t('settings_eType_operations')">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.typeId"
                  size="mini"
                  type="success"
                  plain
                  icon="el-icon-plus"
                  @click="handleAddPhase(scope.$index, scope.row)">{{$t('settings_eType_addPhase')}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              label="">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-edit"
                  @click="scope.row.typeId ? handleEditPhase(scope.$index, scope.row) : handleEditType(scope.$index, scope.row)"></el-button>
                <el-button
                  v-if="!scope.row.isDefault"
                  size="mini"
                  type="danger"
                  plain
                  icon="el-icon-delete"
                  @click="scope.row.typeId ? handleDeletePhase(scope.$index, scope.row) : handleDeleteType(scope.$index, scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>

    <!-- add type -->
    <sweet-modal blocking :title="$t('settings_eType_add')" ref="openModal" class="modal" v-on:close="closeModal">

      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="name">
              <el-input :label="$t('settings_eType_name')" v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addType('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

    <!-- add phase -->
    <sweet-modal blocking :title="$t('settings_eType_addPhase')" ref="openModalAddPhase" class="modal" v-on:close="closeModal">

      <el-form :model="formAddPhase" ref="formAddPhase" status-icon :rules="rulesPhase" label-width="0" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="name">
              <el-input :label="$t('settings_eType_name')" v-model="formAddPhase.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalAddPhase')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addPhase('formAddPhase')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

    <!-- edit type -->
    <sweet-modal blocking :title="$t('settings_eType_edit')" ref="openModalEdit" class="modal" v-on:close="closeModal">

      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="name">
              <el-input :label="$t('settings_eType_name')" v-model="formEdit.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
          <el-button @click="editType('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

    <!-- edit phase -->
    <sweet-modal blocking :title="$t('settings_eType_editPhase')" ref="openModalEditPhase" class="modal" v-on:close="closeModal">

      <el-form :model="formEditPhase" ref="formEditPhase" status-icon :rules="rulesEditPhase" label-width="0" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="name">
              <el-input :label="$t('settings_eType_name')" v-model="formEditPhase.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalEditPhase')">{{$t('general_cancel')}}</el-button>
          <el-button @click="editPhase('formEditPhase')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    components: {
      SweetModal,
    },
    created() {
      this.loadList()
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    data() {
      return {
        moment:moment,
        
        tableData: [],
        selectedRowId: '',
        form:{
          name: '',
        },
        formEdit:{
          name: '',
        },
        formAddPhase:{
          name: '',
        },
        formEditPhase:{
          name: '',
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesPhase: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEditPhase: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      moveTypeStage(type, row) {
        let typeId = null
        let oldOrder = null
        let newOrder = null
        if (row.typeId) {
          typeId = row.typeId
          oldOrder = String(row.order)
          oldOrder = +(oldOrder.slice(2))
        } else {
          oldOrder = row.order
        }

        if (type) {
          if (oldOrder > 1) {
            newOrder = oldOrder - 1
          } else {
            newOrder = 1
          }
        } else {
          newOrder = oldOrder + 1
        }

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/settings/company-type-stage/move?companyId=${this.$route.query.companyId}&id=${row.id}&entityType=${row.entityType == 1 ? 'project' : 'engagement'}&typeId=${typeId}&oldOrder=${oldOrder}&newOrder=${newOrder}`)
          .then(response => {
            this.loadList()
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      loadList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/settings/company-type/list?companyId=${this.$route.query.companyId}&entityType=engagement`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      addType(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/settings/company-type/create?companyId=${this.$route.query.companyId}&entityType=engagement`, {
                name: this.form.name
              })
              .then(response => {
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleEditType(index, row) {
        this.selectedRowId = row.id

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/settings/company-type/item?typeId=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editType(formEdit) {
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/settings/company-type/update?typeId=${this.selectedRowId}`, this.formEdit)
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDeleteType(index, row) {
        this.selectedRowId = row.id

        this.$confirm(row.isUsed ? this.$t('general_deleteTitleResetToDefault') : this.$t('general_deleteTitle'), this.$t('settings_regions_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('general_deleteCompleted')
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/settings/company-type/delete?typeId=${this.selectedRowId}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      handleAddPhase(index, row) {
        this.selectedRowId = row.id
        this.$refs.openModalAddPhase.open()
      },
      addPhase(formAddPhase) {
        this.$refs[formAddPhase].validate((valid) => {
          if (valid) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/settings/company-stage/create?companyId=${this.$route.query.companyId}&typeId=${this.selectedRowId}&entityType=engagement`, {
                name: this.formAddPhase.name
              })
              .then(response => {
                this.$refs.openModalAddPhase.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleEditPhase(index, row) {
        this.selectedRowId = row.id

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/settings/company-stage/item?stageId=${row.id}`)
          .then(response => {
            this.$refs.openModalEditPhase.open()
            this.formEditPhase.name = response.data.item.name
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editPhase(formEditPhase) {
        this.$refs[formEditPhase].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/settings/company-stage/update?stageId=${this.selectedRowId}`, this.formEditPhase)
              .then(response => {
                this.$refs.openModalEditPhase.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDeletePhase(index, row) {
        this.selectedRowId = row.id

        this.$confirm(row.isUsed ? this.$t('general_deleteTitleResetToDefault') : this.$t('general_deleteTitle'), this.$t('settings_regions_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('general_deleteCompleted')
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/settings/company-stage/delete?stageId=${this.selectedRowId}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      openModalAdd(){
        this.$refs.openModal.open()
      },
      closeModal(){
        // this.form.name = ''
        // this.formEdit.name = ''
        // this.formAddPhase.name = ''
        // this.formEditPhase.name = ''
        this.$refs['form'].resetFields()
        this.$refs['formAddPhase'].resetFields()
        this.$refs['formEdit'].resetFields()
        this.$refs['formEditPhase'].resetFields()
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
